import React from "react";
import { Navigate } from "react-router-dom";
import AuthContext from "../context/AuthProvider";

class Logout extends React.Component {
  static contextType = AuthContext;

  constructor(props) {
    super(props);
    this.state = {
      redirect: false
    };
  }

  componentDidMount() {
    this.handleLogout();
  }

  handleLogout() {
    var self = this;
    var ctx = this.context;
    var clearAuth = ctx.clearAuth || function() { ctx.setAuth({}); };

    // Read username from auth context or localStorage
    var username = (ctx.auth && ctx.auth.username) || '';
    if (!username) {
      try { username = JSON.parse(localStorage.getItem('auth') || '{}').username || ''; } catch(e) {}
    }

    fetch(process.env.REACT_APP_URL + "/logout", {
      method: "POST",
      credentials: "include", // send httpOnly cookie
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username: username }),
    })
      .then(function () {
        clearAuth();
        localStorage.removeItem("myc_pwa_dismissed_at");
        self.setState({ redirect: true });
      })
      .catch(function () {
        clearAuth();
        localStorage.removeItem("myc_pwa_dismissed_at");
        self.setState({ redirect: true });
      });
  }

  render() {
    if (this.state.redirect) {
      return <Navigate to="/login" replace />;
    }

    return (
      <div style={{ padding: "2rem", textAlign: "center" }}>
        <h3>Logging out...</h3>
      </div>
    );
  }
}

export default Logout;
